// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Open_Sans_25f576', '__Open_Sans_Fallback_25f576'"},"className":"__className_25f576"};